module.exports = __webpack_public_path__ + "static/img/lannd-bg.8138381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lannd-bg.png
// module id = DKzj
// module chunks = 36